// Session 1-7 Assessment Data with Business Plan Mappings
export const sessionAssessments = {
  "session-1": {
    sessionTitle: "Session 1: The Big Idea",
    sessionNumber: 1,
    businessPlanSection: "executive_summary",
    businessPlanSectionTitle: "Executive Summary",
    knowledgeCheck: [
      {
        id: "s1-q1",
        question: "What is entrepreneurship?",
        options: [
          { id: "A", text: "Watching videos online" },
          { id: "B", text: "Solving problems by creating ideas that help people" },
          { id: "C", text: "Playing a game" },
          { id: "D", text: "Buying things" }
        ],
        correctAnswer: "B",
        feedback: "Entrepreneurs notice problems and create solutions that help people."
      },
      {
        id: "s1-q2",
        question: "Which of these is an example of a problem an entrepreneur might notice?",
        options: [
          { id: "A", text: "People are bored" },
          { id: "B", text: "People are thirsty and need a drink" },
          { id: "C", text: "People are sleeping" },
          { id: "D", text: "People are watching TV" }
        ],
        correctAnswer: "B",
        feedback: "Great entrepreneurs pay attention to everyday problems."
      },
      {
        id: "s1-q3",
        question: "Your lemonade stand is an example of what?",
        options: [
          { id: "A", text: "A hobby" },
          { id: "B", text: "A business" },
          { id: "C", text: "A game" },
          { id: "D", text: "A toy" }
        ],
        correctAnswer: "B",
        feedback: "When you sell something to help people and earn money, that is a business."
      },
      {
        id: "s1-q4",
        question: "True or False: Entrepreneurs must be perfect to succeed.",
        options: [
          { id: "A", text: "True" },
          { id: "B", text: "False" }
        ],
        correctAnswer: "B",
        feedback: "Entrepreneurs learn by trying, making mistakes, and improving."
      }
    ],
    confidencePrompt: "How confident do you feel about understanding entrepreneurship right now?",
    confidenceAutoResponse: "Confidence grows with practice. Wherever you are is exactly where you should be.",
    reflectionQuestions: [
      {
        id: "r1",
        question: "What is one thing you learned in this session?",
        businessPlanLabel: "Key Learning"
      },
      {
        id: "r2",
        question: "What part of entrepreneurship feels exciting to you?",
        businessPlanLabel: "What Excites Me"
      },
      {
        id: "r3",
        question: "What is one question you still have?",
        businessPlanLabel: "Questions to Explore"
      }
    ],
    lemonBotMessage: "Great work completing Session 1. You are thinking like an entrepreneur already. Keep going. Big ideas start small."
  },
  
  "session-2": {
    sessionTitle: "Session 2: Finding Your Niche & Understanding Your Customer",
    sessionNumber: 2,
    businessPlanSection: "team_and_roles",
    businessPlanSectionTitle: "Team & Roles",
    knowledgeCheck: [
      {
        id: "s2-q1",
        question: "What is a customer?",
        options: [
          { id: "A", text: "Someone who watches" },
          { id: "B", text: "Someone who buys from your business" },
          { id: "C", text: "Someone who works with you" },
          { id: "D", text: "Someone who owns a business" }
        ],
        correctAnswer: "B",
        feedback: "Customers are the people your business is helping."
      },
      {
        id: "s2-q2",
        question: "Why is it important to know your customer?",
        options: [
          { id: "A", text: "So you can copy others" },
          { id: "B", text: "So you know how to help them" },
          { id: "C", text: "So you can charge more" },
          { id: "D", text: "So you can finish faster" }
        ],
        correctAnswer: "B",
        feedback: "Great businesses understand who they are helping and why."
      },
      {
        id: "s2-q3",
        question: "Which of these is an example of a customer need?",
        options: [
          { id: "A", text: "Being bored" },
          { id: "B", text: "Wanting something shiny" },
          { id: "C", text: "Being thirsty on a hot day" },
          { id: "D", text: "Watching TV" }
        ],
        correctAnswer: "C",
        feedback: "Entrepreneurs solve real problems people have."
      },
      {
        id: "s2-q4",
        question: "True or False: Every business is for everyone.",
        options: [
          { id: "A", text: "True" },
          { id: "B", text: "False" }
        ],
        correctAnswer: "B",
        feedback: "Most businesses focus on helping a specific group of people."
      }
    ],
    confidencePrompt: "How confident do you feel about knowing who your customer is?",
    confidenceAutoResponse: "Understanding your customer is a powerful business skill. You're building it.",
    reflectionQuestions: [
      {
        id: "r1",
        question: "Who do you think your customer is?",
        businessPlanLabel: "Our Target Customer"
      },
      {
        id: "r2",
        question: "What problem does your customer have?",
        businessPlanLabel: "Customer Problem"
      },
      {
        id: "r3",
        question: "How does your lemonade stand help them?",
        businessPlanLabel: "How We Help"
      }
    ],
    lemonBotMessage: "You are learning how to think about other people's needs. That is what entrepreneurs do."
  },

  "session-3": {
    sessionTitle: "Session 3: Planning for Success",
    sessionNumber: 3,
    businessPlanSection: "operations",
    businessPlanSectionTitle: "Business Plan & Operations",
    knowledgeCheck: [
      {
        id: "s3-q1",
        question: "What does planning mean in a business?",
        options: [
          { id: "A", text: "Guessing what will happen" },
          { id: "B", text: "Thinking ahead and getting ready" },
          { id: "C", text: "Waiting until the last minute" },
          { id: "D", text: "Copying someone else" }
        ],
        correctAnswer: "B",
        feedback: "Planning helps businesses feel prepared and confident."
      },
      {
        id: "s3-q2",
        question: "Why is planning important before selling?",
        options: [
          { id: "A", text: "So you can rush" },
          { id: "B", text: "So you know what to do" },
          { id: "C", text: "So you can change nothing" },
          { id: "D", text: "So you can skip steps" }
        ],
        correctAnswer: "B",
        feedback: "A plan helps teams work together and avoid confusion."
      },
      {
        id: "s3-q3",
        question: "Which of these is part of a simple business plan?",
        options: [
          { id: "A", text: "A secret code" },
          { id: "B", text: "Knowing what you will sell" },
          { id: "C", text: "Guessing the weather" },
          { id: "D", text: "Watching others" }
        ],
        correctAnswer: "B",
        feedback: "Businesses plan what they sell, how much, and who they help."
      },
      {
        id: "s3-q4",
        question: "True or False: Planning helps teams feel more confident.",
        options: [
          { id: "A", text: "True" },
          { id: "B", text: "False" }
        ],
        correctAnswer: "A",
        feedback: "When you have a plan, you feel ready."
      }
    ],
    confidencePrompt: "How confident do you feel about planning for your business?",
    confidenceAutoResponse: "Planning is a powerful skill. You are learning how to prepare for success.",
    reflectionQuestions: [
      {
        id: "r1",
        question: "What is one thing your team planned ahead of time?",
        businessPlanLabel: "Our Planning"
      },
      {
        id: "r2",
        question: "How did planning help your team work better together?",
        businessPlanLabel: "Team Coordination"
      },
      {
        id: "r3",
        question: "What would you add to your plan next time?",
        businessPlanLabel: "Future Improvements"
      }
    ],
    lemonBotMessage: "You thought ahead and made a plan. That's how entrepreneurs prepare for success."
  },

  "session-4": {
    sessionTitle: "Session 4: Branding & Marketing Magic",
    sessionNumber: 4,
    businessPlanSection: "branding_marketing",
    businessPlanSectionTitle: "Branding & Marketing",
    knowledgeCheck: [
      {
        id: "s4-q1",
        question: "What is a brand?",
        options: [
          { id: "A", text: "Just a logo" },
          { id: "B", text: "How your business looks and feels to customers" },
          { id: "C", text: "How much money you make" },
          { id: "D", text: "A rule" }
        ],
        correctAnswer: "B",
        feedback: "A brand is how people remember your business."
      },
      {
        id: "s4-q2",
        question: "What is one example of branding?",
        options: [
          { id: "A", text: "Choosing a business name" },
          { id: "B", text: "Counting money" },
          { id: "C", text: "Making lemonade" },
          { id: "D", text: "Sitting down" }
        ],
        correctAnswer: "A",
        feedback: "Your name, colors, and style all create your brand."
      },
      {
        id: "s4-q3",
        question: "What is marketing?",
        options: [
          { id: "A", text: "Hiding your business" },
          { id: "B", text: "Telling people about your business" },
          { id: "C", text: "Forgetting about customers" },
          { id: "D", text: "Taking a break" }
        ],
        correctAnswer: "B",
        feedback: "Marketing helps people discover your business."
      },
      {
        id: "s4-q4",
        question: "True or False: Creativity can help a business stand out.",
        options: [
          { id: "A", text: "True" },
          { id: "B", text: "False" }
        ],
        correctAnswer: "A",
        feedback: "Creative ideas help customers notice and remember you."
      }
    ],
    confidencePrompt: "How confident do you feel about branding and marketing your business?",
    confidenceAutoResponse: "Creativity grows when you share your ideas. You're doing great.",
    reflectionQuestions: [
      {
        id: "r1",
        question: "What is your business name and why did you choose it?",
        businessPlanLabel: "Business Name & Story"
      },
      {
        id: "r2",
        question: "What colors, signs, or ideas helped your business stand out?",
        businessPlanLabel: "Brand Identity"
      },
      {
        id: "r3",
        question: "How did your marketing help attract customers?",
        businessPlanLabel: "Marketing Strategy"
      }
    ],
    lemonBotMessage: "You shared your ideas and creativity with the world. That's marketing magic."
  },

  "session-5": {
    sessionTitle: "Session 5: Financial Savvy",
    sessionNumber: 5,
    businessPlanSection: "pricing_money",
    businessPlanSectionTitle: "Pricing & Money",
    knowledgeCheck: [
      {
        id: "s5-q1",
        question: "Why is money important in a business?",
        options: [
          { id: "A", text: "So you can show off" },
          { id: "B", text: "So the business can keep going" },
          { id: "C", text: "So you can rush" },
          { id: "D", text: "So you can hide it" }
        ],
        correctAnswer: "B",
        feedback: "Money helps a business pay for supplies and grow."
      },
      {
        id: "s5-q2",
        question: "What does profit mean?",
        options: [
          { id: "A", text: "All the money you collect" },
          { id: "B", text: "Money left after paying your costs" },
          { id: "C", text: "The price of lemonade" },
          { id: "D", text: "Extra change" }
        ],
        correctAnswer: "B",
        feedback: "Profit helps your business continue and improve."
      },
      {
        id: "s5-q3",
        question: "What is one smart money habit in business?",
        options: [
          { id: "A", text: "Guessing" },
          { id: "B", text: "Counting carefully" },
          { id: "C", text: "Rushing" },
          { id: "D", text: "Ignoring mistakes" }
        ],
        correctAnswer: "B",
        feedback: "Careful counting helps build trust."
      },
      {
        id: "s5-q4",
        question: "True or False: Being honest with money is part of being a good entrepreneur.",
        options: [
          { id: "A", text: "True" },
          { id: "B", text: "False" }
        ],
        correctAnswer: "A",
        feedback: "Honesty builds trust with customers and teammates."
      }
    ],
    confidencePrompt: "How confident do you feel about handling money in your business?",
    confidenceAutoResponse: "Money skills grow with practice. You're learning something important.",
    reflectionQuestions: [
      {
        id: "r1",
        question: "What was one money decision your team had to make?",
        businessPlanLabel: "Key Financial Decision"
      },
      {
        id: "r2",
        question: "How did your team make sure money was counted fairly and carefully?",
        businessPlanLabel: "Money Management"
      },
      {
        id: "r3",
        question: "What is one money rule you think every business should follow?",
        businessPlanLabel: "Financial Principle"
      }
    ],
    lemonBotMessage: "You handled money with care and honesty. That's what financially savvy entrepreneurs do."
  },

  "session-6": {
    sessionTitle: "Session 6: Overcoming Challenges",
    sessionNumber: 6,
    businessPlanSection: "challenges",
    businessPlanSectionTitle: "Challenges & Problem-Solving",
    knowledgeCheck: [
      {
        id: "s6-q1",
        question: "What is a challenge in business?",
        options: [
          { id: "A", text: "Something that means you failed" },
          { id: "B", text: "A problem that needs a solution" },
          { id: "C", text: "A reason to quit" },
          { id: "D", text: "Something to avoid" }
        ],
        correctAnswer: "B",
        feedback: "Challenges are problems entrepreneurs learn to solve."
      },
      {
        id: "s6-q2",
        question: "Which of these is an example of a business challenge?",
        options: [
          { id: "A", text: "Customers enjoying lemonade" },
          { id: "B", text: "Not many customers stopping by" },
          { id: "C", text: "Having a good plan" },
          { id: "D", text: "Working as a team" }
        ],
        correctAnswer: "B",
        feedback: "Challenges happen when things don't go as expected."
      },
      {
        id: "s6-q3",
        question: "What is a smart response to a challenge?",
        options: [
          { id: "A", text: "Give up" },
          { id: "B", text: "Get angry" },
          { id: "C", text: "Ask for help and try a new idea" },
          { id: "D", text: "Ignore it" }
        ],
        correctAnswer: "C",
        feedback: "Entrepreneurs adjust, learn, and keep going."
      },
      {
        id: "s6-q4",
        question: "True or False: Every entrepreneur faces challenges.",
        options: [
          { id: "A", text: "True" },
          { id: "B", text: "False" }
        ],
        correctAnswer: "A",
        feedback: "Challenges are part of every business journey."
      }
    ],
    confidencePrompt: "How confident do you feel about handling challenges in your business?",
    confidenceAutoResponse: "Challenges help you grow stronger. You're learning how to handle them.",
    reflectionQuestions: [
      {
        id: "r1",
        question: "What was one challenge your team faced?",
        businessPlanLabel: "Challenge We Faced"
      },
      {
        id: "r2",
        question: "How did your team try to solve that challenge?",
        businessPlanLabel: "Our Solution"
      },
      {
        id: "r3",
        question: "What did you learn from this experience?",
        businessPlanLabel: "Lesson Learned"
      }
    ],
    lemonBotMessage: "You didn't quit when things got hard. That's what entrepreneurs do."
  },

  "session-7": {
    sessionTitle: "Session 7: The Sweet Taste of Success",
    sessionNumber: 7,
    businessPlanSection: "pitch_vision",
    businessPlanSectionTitle: "Pitch & Vision",
    pitchReadinessCheck: [
      {
        id: "s7-pr1",
        question: "Which part of your pitch do you feel strongest about?",
        options: [
          { id: "A", text: "The hook" },
          { id: "B", text: "The problem" },
          { id: "C", text: "The solution" },
          { id: "D", text: "What makes us special" },
          { id: "E", text: "The ask" }
        ],
        type: "checkbox",
        feedback: "Knowing your strengths helps you pitch with confidence."
      },
      {
        id: "s7-pr2",
        question: "How do you feel about presenting your pitch today?",
        options: [
          { id: "A", text: "Nervous", emoji: "😟" },
          { id: "B", text: "A little nervous but ready", emoji: "😐" },
          { id: "C", text: "Confident", emoji: "🙂" },
          { id: "D", text: "Excited", emoji: "🚀" }
        ],
        type: "confidence",
        feedback: "Nerves mean you care. Confidence grows when you try."
      }
    ],
    knowledgeCheck: [
      {
        id: "s7-q1",
        question: "What is the purpose of a business pitch?",
        options: [
          { id: "A", text: "To talk for a long time" },
          { id: "B", text: "To explain your business and invite support" },
          { id: "C", text: "To memorize words" },
          { id: "D", text: "To impress friends" }
        ],
        correctAnswer: "B",
        feedback: "A pitch helps people understand your idea and want to support it."
      },
      {
        id: "s7-q2",
        question: "Which part of a pitch comes first?",
        options: [
          { id: "A", text: "The ask" },
          { id: "B", text: "The solution" },
          { id: "C", text: "The hook" },
          { id: "D", text: "The results" }
        ],
        correctAnswer: "C",
        feedback: "The hook grabs attention right away."
      },
      {
        id: "s7-q3",
        question: "True or False: A good pitch must be perfect to be successful.",
        options: [
          { id: "A", text: "True" },
          { id: "B", text: "False" }
        ],
        correctAnswer: "B",
        feedback: "Confidence and effort matter more than perfection."
      }
    ],
    pitchDeliveryOptions: [
      { id: "live", text: "Live in front of class" },
      { id: "recorded", text: "Recorded video" },
      { id: "small-group", text: "Small group presentation" }
    ],
    confidencePrompt: "How do you feel about yourself after completing this program?",
    confidenceAutoResponse: "You did it. You shared your idea with courage and confidence. That is what entrepreneurs do.",
    reflectionQuestions: [
      {
        id: "r1",
        question: "What part of your pitch are you most proud of?",
        businessPlanLabel: "Pitch Highlight"
      },
      {
        id: "r2",
        question: "What is one thing you would improve next time?",
        businessPlanLabel: "Future Improvement"
      },
      {
        id: "r3",
        question: "How do you feel about yourself after completing this program?",
        type: "emoji-scale",
        businessPlanLabel: "Final Reflection"
      }
    ],
    lemonBotMessage: "You did it. You shared your idea with courage and confidence. That is what entrepreneurs do.",
    certificateTitle: "Certified Young Entrepreneur",
    certificateMessage: "This certificate recognizes your creativity, teamwork, confidence, and entrepreneurial mindset."
  }
};

// Business Plan Section Configuration
export const businessPlanSections = [
  {
    id: "executive_summary",
    title: "Executive Summary",
    sessionNumber: 1,
    icon: "💡",
    description: "Your big idea and what you learned about being an entrepreneur"
  },
  {
    id: "team_and_roles",
    title: "Team & Roles",
    sessionNumber: 2,
    icon: "👥",
    description: "Who your customers are and how you help them"
  },
  {
    id: "operations",
    title: "Business Plan & Operations",
    sessionNumber: 3,
    icon: "📋",
    description: "How you planned and organized your business"
  },
  {
    id: "branding_marketing",
    title: "Branding & Marketing",
    sessionNumber: 4,
    icon: "🎨",
    description: "Your brand identity and how you attracted customers"
  },
  {
    id: "pricing_money",
    title: "Pricing & Money",
    sessionNumber: 5,
    icon: "💰",
    description: "How you handled money and made financial decisions"
  },
  {
    id: "challenges",
    title: "Challenges & Problem-Solving",
    sessionNumber: 6,
    icon: "🧩",
    description: "Problems you faced and how you solved them"
  },
  {
    id: "pitch_vision",
    title: "Pitch & Vision",
    sessionNumber: 7,
    icon: "🎯",
    description: "Your final pitch and vision for the future"
  }
];
